export default (days: number = 7) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + 60 * 60 * 24 * days * 1000); // 1 week
  return expires;
};
